// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.4141 13L18.4141 14H19C21.7614 14 24 16.2386 24 19C24 21.7614 21.7614 24 19 24C16.2386 24 14 21.7614 14 19V18H16V19C16 20.6569 17.3431 22 19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16H18.4141L19.4141 17L18 18.4141L14.5859 15L18 11.5859L19.4141 13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.5 10.9277C20.718 10.6513 19.8767 10.5 19 10.5C14.8579 10.5 11.5 13.8579 11.5 18L11.5098 18.3857C11.5878 19.9259 12.132 21.3423 13.002 22.5H2.5V1.5H21.5V10.9277ZM7 13H12V11H7V13ZM7 9H17V7H7V9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-document-update-filled')
export default class DocumentUpdateFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'document-update-filled',
    }
  }
}
